module.exports = __webpack_public_path__ + "static/media/2.7fc62e4e.jpg";